import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TFileUploadResponse } from '@prlw/libs/file-upload/types';
import { IconsModule } from '@prlw/libs/icons/icons.module';
import { FileUploadProgressComponent } from '../../features/profile/license-tab/file-upload-overlay/file-upload-progress/file-upload-progress.component';

@Component({
  selector: 'prlw-attached-files-ui',
  imports: [CommonModule, IconsModule, FileUploadProgressComponent],
  templateUrl: './attached-files.component.html',
  styleUrl: './attached-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachedFilesComponent<T> {
  @Input() attachedFiles: Array<
    TFileUploadResponse<T> & { fileName: string }
  > | null = null;

  @Output() eventRemoveAttachedFile = new EventEmitter<string>();

  hasError(item: TFileUploadResponse<T> & { fileName: string }) {
    return 'error' in item;
  }

  hasProgress(item: TFileUploadResponse<T> & { fileName: string }) {
    return 'progress' in item;
  }
}
